import React, { useEffect, useState } from 'react'
import { useIsMount } from '../../utils'
import { Slider, Track, SwitchLabel } from './styles'

type Props = {
  'data-qa'?: string
  defaultState?: boolean
  disabled?: boolean
  onChange: (event) => any
  size?: 'large' | 'medium'
  style?: object
}

const Switch: React.FC<Props> = (props: Props): JSX.Element => {
  const [state, setState] = useState<boolean>(props.defaultState)

  const isMountRef = useIsMount()

  useEffect(() => {
    if (!isMountRef) props.onChange(state)
  }, [state])

  return (
    <Track className={`${props.size}`} data-qa={props['data-qa']}>
      <SwitchLabel>
        <input
          type="checkbox"
          disabled={props.disabled}
          checked={state}
          data-qa={props['data-qa'] && `${props['data-qa']}-input`}
          onClick={() => setState(!state)}
          readOnly
        />
        <Slider />
      </SwitchLabel>
    </Track>
  )
}

Switch.defaultProps = {
  size: 'medium',
  defaultState: false,
}

export default Switch
